import { render, staticRenderFns } from "./PayingProccess.vue?vue&type=template&id=35be73d8&"
import script from "./PayingProccess.vue?vue&type=script&lang=js&"
export * from "./PayingProccess.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports